"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPaymentDataToJSON = exports.StoredPaymentDataFromJSONTyped = exports.StoredPaymentDataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function StoredPaymentDataFromJSON(json) {
    return StoredPaymentDataFromJSONTyped(json, false);
}
exports.StoredPaymentDataFromJSON = StoredPaymentDataFromJSON;
function StoredPaymentDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'directDebit': !(0, runtime_1.exists)(json, 'directDebit') ? undefined : (0, _1.StoredPaymentDataDirectDebitFromJSON)(json['directDebit']),
        'creditCard': !(0, runtime_1.exists)(json, 'creditCard') ? undefined : (0, _1.StoredPaymentDataCreditCardFromJSON)(json['creditCard']),
        'bankAccount': !(0, runtime_1.exists)(json, 'bankAccount') ? undefined : (0, _1.StoredPaymentDataBankAccountFromJSON)(json['bankAccount']),
    };
}
exports.StoredPaymentDataFromJSONTyped = StoredPaymentDataFromJSONTyped;
function StoredPaymentDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'directDebit': (0, _1.StoredPaymentDataDirectDebitToJSON)(value.directDebit),
        'creditCard': (0, _1.StoredPaymentDataCreditCardToJSON)(value.creditCard),
        'bankAccount': (0, _1.StoredPaymentDataBankAccountToJSON)(value.bankAccount),
    };
}
exports.StoredPaymentDataToJSON = StoredPaymentDataToJSON;
//# sourceMappingURL=StoredPaymentData.js.map